{
  "app": {
    "name": "Fermin Admin",
    "brand": "Fermin"
  },
  "buttons": {
    "save": "Guardar",
    "create": "Crear",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "edit": "Editar",
    "delete": "Eliminar",
    "confirm": "Confirmar",
    "back": "Volver",
    "retry": "Reintentar",
    "search": "Buscar",
    "clear": "Limpiar",
    "copy": "Copiar",
    "copied": "Copiado",
    "loadMore": "Cargar más",
    "seeChange": "Ver cambio",
    "refresh": "Actualizar"
  },
  "states": {
    "loading": "Cargando…",
    "processing": "Procesando…",
    "saving": "Guardando…",
    "empty": "No hay nada que mostrar todavía.",
    "noResults": "No encontramos resultados con esos filtros.",
    "required": "Este campo es obligatorio."
  },
  "filters": {
    "clear": "Limpiar filtros",
    "pending": "Hay filtros sin aplicar: pulsa Buscar para verlos."
  },
  "refresh": {
    "justNow": "Actualizado hace un momento",
    "secondsAgo": "Actualizado hace {value} s",
    "minutesAgo": "Actualizado hace {value} min",
    "hoursAgo": "Actualizado hace {value} h",
    "announced": "Datos actualizados"
  },
  "badges": {
    "activa": "Activa",
    "pendiente": "Pendiente",
    "inactiva": "Inactiva",
    "suspendida": "Suspendida",
    "online": "En línea",
    "offline": "Sin conexión",
    "valida": "Válida",
    "observada": "Observada",
    "manual": "Manual",
    "anulada": "Anulada",
    "reemplazada": "Reemplazada",
    "pedida": "Pedida",
    "aprobada": "Aprobada",
    "rechazada": "Rechazada",
    "cancelada": "Cancelada"
  },
  "banners": {
    "support": "Modo soporte · {company}",
    "supportExit": "Salir del modo soporte",
    "suspended": "Empresa suspendida · solo lectura. Contacta a Fermin.",
    "suspendedTooltip": "La empresa está suspendida: solo lectura."
  },
  "notFound": {
    "title": "No encontramos este recurso",
    "description": "Puede que se haya eliminado o que no tengas acceso a él.",
    "action": "Ir al inicio"
  },
  "errors": {
    "VALIDATION_ERROR": "Revisa los datos del formulario.",
    "UNAUTHENTICATED": "Tu sesión terminó. Vuelve a ingresar.",
    "FORBIDDEN": "No tienes permiso para hacer esto.",
    "NOT_FOUND": "No encontramos este recurso",
    "CONFLICT": "Ya existe un registro con esos datos.",
    "LAST_ADMIN": "No puedes deshabilitar al último administrador de la empresa.",
    "TOKEN_EXPIRED": "Este enlace venció. Pide uno nuevo a tu administrador.",
    "TOKEN_INVALID": "Este enlace ya no es válido. Pide uno nuevo a tu administrador.",
    "PASSWORD_WEAK": "La contraseña debe tener entre 10 y 128 caracteres.",
    "PASSWORD_COMPROMISED": "Esa contraseña apareció en filtraciones conocidas. Elige otra.",
    "INVALID_TIMEZONE": "La zona horaria no es válida.",
    "ACCOUNT_LOCKED": "Demasiados intentos. Vuelve a intentarlo en un momento.",
    "READ_ONLY": "Empresa suspendida · solo lectura. Contacta a Fermin.",
    "RATE_LIMITED": "Demasiadas solicitudes. Espera un momento.",
    "CONFIRMATION_REQUIRED": "Revisa las advertencias antes de guardar.",
    "MARK_NOT_CURRENT": "Esta marcación ya fue reemplazada o anulada. Revisa la marcación vigente.",
    "WORKER_ANONYMIZED": "Este trabajador fue anonimizado y ya no puede modificarse.",
    "REGULARIZATION_NOT_OPEN": "Esta solicitud ya no está pendiente. Actualizamos la bandeja.",
    "REGULARIZATION_UNAVAILABLE": "No se puede regularizar esta marca.",
    "PERIOD_CLOSED": "Ese período está cerrado. Reábrelo para hacer cambios.",
    "INTEGRATION_MANAGED": "Este dato viene de un sistema integrado y no se puede cambiar aquí.",
    "JUSTIFICATION_NOT_OPEN": "Esta justificación ya no está pendiente.",
    "JUSTIFICATION_UNAVAILABLE": "No se puede justificar este día.",
    "INTEGRATION_UNAVAILABLE": "La integración no está disponible.",
    "INTEGRATION_COMPANY_MISMATCH": "La clave corresponde a otra empresa ({received}) y no a la vinculada ({bound}). Revisa la clave.",
    "INTERNAL_ERROR": "Ocurrió un error inesperado. Inténtalo nuevamente.",
    "NETWORK": "No pudimos conectarnos con el servidor. Revisa tu conexión."
  },
  "integrationUnavailable": {
    "NOT_CONFIGURED": "Primero configura la conexión con tu sistema.",
    "DISABLED": "La integración está desactivada.",
    "SECRET_KEY_MISSING": "La integración no está disponible en este servidor.",
    "NOT_VERIFIED": "Prueba la conexión antes de sincronizar.",
    "RESOURCE_NOT_OFFERED": "Tu sistema no ofrece este dato.",
    "SYNC_DISABLED": "En este servidor no se puede sincronizar; usa el ambiente de QA."
  },
  "conflictReasons": {
    "REVIEW_NOT_OPEN": "Este caso ya fue resuelto.",
    "ALREADY_LINKED": "Ese registro de Fermin ya está vinculado a otro del sistema externo.",
    "RUN_NOT_AWAITING_CONFIRMATION": "Esta sincronización ya no espera confirmación."
  }
}
